export default "__VITE_ASSET__BxU6hk8O__"